<template>
  <div class="class-title">
    <dr-column>
      <dr-row justifyContent="space-between" class="item">
        <dr-row justifyContent="flex-start" alignItems="center">
          <van-icon v-if="iconName" :name="iconName" size="14" class="margin-right5" />
          {{title}}
        </dr-row>
        <dr-row style="width: 70%;" justifyContent="flex-end">
          <slot>
            <div class="detail-content" :style="{'color' : rightContentTextColor}">{{rightContent}}</div>
          </slot>
          <van-icon class="margin-left5" v-if="hasArrow" name="static/imgs/arrow_right.png" size="8" />
        </dr-row>
      </dr-row>
      <div v-if="hasDivider" class="divider"></div>
    </dr-column>
  </div>
</template>

<script>
export default {
  props: {
    flag: {
      type: String,
      default: '', // 记录操作
    },
    title: {
      type: String,
      default: '',
    },
    hasDivider: {
      type: Boolean,
      default: true,
    },
    hasArrow: {
      type: Boolean,
      default: true,
    },
    iconName: {
      type: String,
      default: '',
    },
    rightContent: {
      type: String,
      default: '',
    },
    rightContentTextColor: {
      type: String,
      default: '#666666',
    }
  },
  data () {
    return {

    }
  },
  methods: {
    onItemClick () {
      this.$emit('onItemClick', this.flag)
    }
  }
}
</script>

<style scoped>
.class-title {
  font-size: 14px;
  color: #333333;
  line-height: 17px;
}

.margin-right5 {
  margin-right: 5px;
}

.margin-left5 {
  margin-left: 5px;
}

.item {
  padding: 17px 11px 17px 14px;
}

.divider {
  width: 100%;
  height: 1px;
  background: #eeeeee;
}

.detail-content {
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/drInfoItem/index.vue